import { render, staticRenderFns } from "./Postreport.vue?vue&type=template&id=036e80b0&scoped=true&"
import script from "./Postreport.vue?vue&type=script&lang=js&"
export * from "./Postreport.vue?vue&type=script&lang=js&"
import style0 from "./Postreport.vue?vue&type=style&index=0&id=036e80b0&scoped=true&lang=css&"
import style1 from "./Postreport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e80b0",
  null
  
)

export default component.exports